export default function Technologies() {
  const techCategories = [
    {
      title: 'Platforms & CMS',
      items: ['Shopify', 'WordPress', 'Wix', 'Webflow', 'Squarespace', 'Drupal']
    },
    {
      title: 'Frontend Development',
      items: ['React', 'Vue.js', 'Next.js', 'TypeScript', 'Tailwind CSS', 'Angular']
    },
    {
      title: 'Backend & Database',
      items: ['Node.js', 'Python', 'PHP', 'MongoDB', 'PostgreSQL', 'MySQL']
    },
    {
      title: 'Mobile Development',
      items: ['React Native', 'Flutter', 'Swift', 'Kotlin', 'Ionic', 'Xamarin']
    },
    {
      title: 'Cloud & DevOps',
      items: ['AWS', 'Google Cloud', 'Azure', 'Docker', 'Kubernetes', 'CI/CD']
    },
    {
      title: 'Design & Animation',
      items: ['Figma', 'Adobe XD', 'Blender', 'After Effects', 'Cinema 4D', 'Premiere Pro']
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-purple-600 font-semibold text-sm uppercase tracking-wider">Technologies</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Cutting-Edge Tech Stack
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We leverage the latest technologies and industry-leading tools to build powerful, scalable solutions that stand the test of time.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {techCategories.map((category, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 border border-gray-100 hover:shadow-xl transition-all duration-300 cursor-pointer group"
            >
              <h3 className="text-2xl font-bold text-gray-900 mb-6 group-hover:text-purple-600 transition-colors">
                {category.title}
              </h3>
              
              <div className="flex flex-wrap gap-3">
                {category.items.map((item, idx) => (
                  <span 
                    key={idx}
                    className="px-4 py-2 bg-white rounded-full text-sm font-medium text-gray-700 border border-gray-200 hover:border-purple-300 hover:text-purple-600 transition-all cursor-pointer whitespace-nowrap"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-6">
            And many more technologies tailored to your specific needs
          </p>
          <a 
            href="https://www.upwork.com/freelancers/~01b46c89a2cd6f5a73?mp_source=share"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-purple-600 to-blue-600 text-white px-8 py-4 rounded-full font-semibold hover:shadow-lg transition-all cursor-pointer whitespace-nowrap group"
          >
            Discuss Your Tech Stack
            <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform inline-block"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
